export const initialFormValues = {
  name: '',
  alias: '',
  registrationNumber: '',
  vatNumber: '',
  emailPrefix: '',
  userId: '',
  currencyId: ''
};
